/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Role Permissions View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './RolePermissionsView';

export const mapStateToPropsRolePermManagement = mapStateToProps;
export const mapDispatchToPropsRolePermManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsRolePermManagement,
  mapDispatchToPropsRolePermManagement
)(View);
